var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mb-4"},[_c('h2',{staticClass:"text-center text-lg lg:text-xl max-w-3/4 m-auto mt-4"},[_vm._v(_vm._s(_vm.finalTitle))])])}
var staticRenderFns = []

export { render, staticRenderFns }